import { TipoAtendimentoEnum } from "../../../enums/tipoAtendimento";
import { IAgendamentoDTO } from "../../../types/agendamento";
import { IEnderecoDTO } from "../../../types/endereco";

export interface IUnidadeResponsavel {
  titulo: string;
  endereco: string[];
}

export interface ILocalAtendimento {
  titulo?: string;
  nome?: string;
  telefone?: string;
  endereco: IEnderecoDTO;
}

/** Loja → name + address; Delivery/Itinerante → just the delivery's city. */
export function getUnidadeResponsavel(
  agendamento?: IAgendamentoDTO,
): IUnidadeResponsavel {
  const tipo = agendamento?.tipoAtendimento;

  if (tipo === TipoAtendimentoEnum.LOJA) {
    const endereco = agendamento?.loja?.endereco;
    const rua = [endereco?.logradouro, endereco?.numero, endereco?.bairro]
      .filter(Boolean)
      .join(", ");
    const cidade = [endereco?.cidade, endereco?.uf].filter(Boolean).join("/");

    return {
      titulo: agendamento?.loja?.nome || "---",
      endereco: [rua, cidade].filter(Boolean),
    };
  }

  const cidadeDelivery =
    tipo === TipoAtendimentoEnum.ITINERANTE
      ? agendamento?.itinerante?.delivery?.cidade ||
        agendamento?.itinerante?.endereco?.cidade
      : agendamento?.delivery?.cidade;

  return { titulo: cidadeDelivery || "---", endereco: [] };
}

/**
 * RQ.02: only Delivery/Itinerante have a "Local de Atendimento". Delivery
 * carries nome/telefone (and the concessionária name when applicable);
 * Itinerante is address-only.
 */
export function getLocalAtendimento(
  agendamento?: IAgendamentoDTO,
): ILocalAtendimento | null {
  const tipo = agendamento?.tipoAtendimento;

  if (tipo === TipoAtendimentoEnum.DOMICILIO) {
    const atendimento = agendamento?.atendimentoDomiciliar;

    if (!atendimento?.endereco) return null;

    return {
      titulo: agendamento?.concessionaria
        ? atendimento?.concessionaria?.nome
        : undefined,
      nome: atendimento?.nome,
      telefone: atendimento?.telefone,
      endereco: atendimento.endereco,
    };
  }

  if (tipo === TipoAtendimentoEnum.ITINERANTE) {
    const endereco = agendamento?.itinerante?.endereco;

    return endereco ? { endereco } : null;
  }

  return null;
}
